/**
 * TM Drawer Accordion v1
 * Overrides Dawn's slide-panel mobile menu behavior
 * to use true inline accordion expand/collapse instead.
 *
 * Dawn's header-drawer.js listens for summary clicks and
 * calls this.open() which triggers the slide animation.
 * We stop that by intercepting the click before it reaches
 * Dawn's listener, letting the native <details> toggle handle it.
 */
(function () {
  'use strict';

  function initAccordion() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return;
    if (drawer.dataset.tmAccordion === 'true') return;
    drawer.dataset.tmAccordion = 'true';

    // Find all summary elements inside the drawer nav
    var summaries = drawer.querySelectorAll(
      '.menu-drawer__navigation summary.menu-drawer__menu-item'
    );

    summaries.forEach(function (summary) {
      summary.addEventListener('click', function (e) {
        // Stop Dawn's JS from catching this click
        e.stopImmediatePropagation();

        var details = summary.closest('details');
        if (!details) return;

        var isOpen = details.hasAttribute('open');

        // Close all other open details at the same level first
        var parentList = details.parentElement;
        if (parentList) {
          var siblings = parentList.querySelectorAll(':scope > li > details[open]');
          siblings.forEach(function (sib) {
            if (sib !== details) sib.removeAttribute('open');
          });
        }

        // Toggle this one
        if (isOpen) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }

        // Prevent default so native toggle doesn't double-fire
        e.preventDefault();
      }, true); // useCapture = true so we fire BEFORE Dawn's listener
    });
  }

  // Run after Dawn's custom elements are defined
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initAccordion, 100);
    });
  } else {
    setTimeout(initAccordion, 100);
  }

  // Also re-run when the drawer opens (Dawn re-renders it)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[aria-controls="menu-drawer"], .header__icon--menu');
    if (trigger) {
      setTimeout(initAccordion, 300);
    }
  });

})();
